export const USER = 'user'
// export const DICH_VU = 'dich-vu'
const ROUTER = {
  DEFAULT: '/',
  SVG_VIEWER: '/svg-viewer',
  RECEIVER: '/receiver',
  HOME: '/',
  AUTH_CALLBACK: '/auth/callback',

  //ANONYMOUS
  CAP_NHAT_THONG_TIN: '/cap-nhat-thong-tin',
  LICH_HOP_CUA_TOI: '/lich-hop-cua-toi',
  DANG_KY_LICH_HOP: '/dang-ky-lich-hop',
  DANG_KY_RA_VAO: '/dang-ky-ra-vao',
  // DANG_KY_KHACH: '/dang-ky-khach',
  DANG_KY_THONG_TIN_KHACH: '/dang-ky-thong-tin-khach',
  CHI_TIET_LICH_HOP: '/chi-tiet-lich-hop',
  DANG_KY_KHACH: '/dang-ky-khach',
  DANG_KY_NGUOI_DUNG_CHUNG: '/dang-ky-nguoi-dung-chung',
  DANG_KY_NGUOI_DUNG_DAY_DU: '/dang-ky-nguoi-dung-day-du',

  // ADMIN
  DASHBOARD: '/dashboard',
  CAU_HINH_LUONG_DUYET: '/cau-hinh-luong-duyet',
  ROLE_MANAGEMENT: `/role-management`,
  USER_MANAGEMENT: `/user-management`,
  TONG_QUAN: '/tong-quan',
  QUAN_LY_LICH_HOP: '/quan-ly-lich-hop',
  QUAN_LY_VI_TRI: '/quan-ly-vi-tri',

  NGHI_PHEP: '/nghi-phep',
  CHI_TIET_NGHI_PHEP: '/thong-ke-nghi-phep/chi-tiet',
  THONG_KE_RA_VAO: '/thong-ke-ra-vao',
  THONG_KE_RA_VAO_V2: '/thong-ke-ra-vao2',
  THONG_KE_NGHI_PHEP: '/acs/thong-ke-nghi-phep',
  DANH_SACH_VI_PHAM: '/danh-sach-vi-pham',
  THONG_KE_VI_PHAM: '/thong-ke-vi-pham',
  QUAN_LY_PHONG_HOP: '/quan-ly-phong-hop',
  QUAN_LY_PHIEU: '/acs/quan-ly-phieu',
  DANH_SACH_KHACH: '/danh-sach-khach',
  PHAT_HIEN_RA_VAO: '/phat-hien-ra-vao',
  QUAN_LY_PHAN_QUYEN: '/phan-quyen',
  QUAN_LY_DANH_MUC_CHUC_NANG: '/danh-muc-chuc-nang',

  DANH_BA_NHAN_VIEN: '/danh-ba-nhan-vien',
  CAI_DAT_TAI_KHOAN: '/cai-dat-tai-khoan',
  NHAN_VIEN_VI_PHAM: '/nhan-vien-vi-pham',
  THONG_TIN_THIET_BI: '/thong-tin-thiet-bi',
  QUAN_LY_CUA: '/quan-ly-cua',
  QUAN_LY_PHUONG_TIEN: '/quan-ly-phuong-tien',
  TRAM_SAC: '/tram-sac',
  CAMERA: '/camera',
  // giám sát nhân viên
  CHAM_CONG: '/hrm/cham-cong',
  GIAM_SAT_NHAN_VIEN: '/acs/giam-sat-nhan-vien',
  THONG_TIN_CA_LAM_VIEC: '/acs/thong-tin-ca-lam-viec',
  QUAN_LY_SU_KIEN: '/acs/quan-ly-su-kien',
  VI_PHAM: '/vi-pham',
  CHI_TIET_NGHI_PHEP_CUA_TOI: `/${USER}/chi-tiet-nghi-phep-cua-toi`,
  CHI_TIET_VI_PHAM: '/chi-tiet-vi-pham/:id',
  VI_PHAM_CUA_TOI: `/${USER}/vi-pham-cua-toi`,
  DUYET_FACE_ID: '/duyet-face-id',
  THONG_TIN_CHECK_IN: '/thong-tin-check-in',
  DUYET_TAI_KHOAN_NHAN_VIEN: '/duyet-tai-khoan-nhan-vien',
  DANH_SACH_CHUC_VU: '/danh-sach-chuc-vu',
  CAU_HINH_NGHI_PHEP: '/cau-hinh-nghi-phep',
  DUYET_THAY_DOI_THONG_TIN: '/duyet-thay-doi-thong-tin',
  DUYET_DON_NGHI: '/duyet-don-nghi',
  LiCH_LAM_VIEC_LAM_BU: '/lich-lam-viec',
  DIEM_DANH_HOP: '/diem-danh-hop',
  DANH_SACH_DAI_BIEU: '/danh-sach-dai-bieu',
  DANH_SACH_CUOC_HOP: '/danh-sach-cuoc-hop',
  DANH_SACH_NHAN_VIEN_DA_CHECK_IN: '/danh-sach-nhan-vien-da-check-in',
  DANH_SACH_NHAN_VIEN: '/danh-sach-nhan-vien',
  BANG_CONG: `/${USER}/bang-cong`,
  LICH_NAM: '/lich-nam',
  CHI_TIET_KHACH_HEN: '/chi-tiet-khach-hen',
  THONG_KE_NGHI_PHEP_SYSTEM: '/thong-ke-nghi-phep-he-thong',
  NGHI_PHEP_LIST: '/danh-sach-nghi-phep',

  //User
  USER: USER,
  THONG_TIN_TAI_KHOAN: `/${USER}/thong-tin-ca-nhan`,
  TONG_QUAN_CUA_TOI: `/${USER}/tong-quan`,
  LICH_LAM_VIEC_CUA_TOI: `/${USER}/lich-lam-viec`,
  SO_YEU_LY_LICH_CUA_TOI: `/${USER}/so-yeu-ly-lich`,
  HOP_DONG_CUA_TOI: `/${USER}/hop-dong`,
  BANG_CAP_CHUNG_CHI_CUA_TOI: `/${USER}/bang-cap-chung-chi`,
  LICH_SU_CAP_NHAT_THONG_TIN: `/${USER}/lich-su-cap-nhat-thong-tin`,
  DANH_SACH_PHIEU: `/${USER}/danh-sach-phieu`,
  CHANGE_PASSWORD: `/${USER}/doi-mat-khau`,
  XU_LY_KHIEU_NAI: '/acs/xu-ly-khieu-nai',
  CHI_TIET_KHIEU_NAI: '/chi-tiet-khieu-nai/:id',
  // ACS
  THONG_TIN_CHUNG: '/acs/thong-tin-chung',
  THONG_TIN_QUET_THE: '/acs/thong-tin-quet-the',
  LICH_TRUC: '/acs/lich-truc',
  THONG_TIN_TIEN_PHAT: '/acs/thong-tin-tien-phat',
  DANG_KY_DOI_CA: '/acs/dang-ky-doi-ca',
  THONG_TIN_THEO_DOI: '/acs/thong-tin-theo-doi',
  THONG_KE_CONG_TAC_PHI: '/acs/thong-ke-cong-tac-phi',
  QUAN_LY_CA_LAM_VIEC: '/acs/quan-ly-ca-lam-viec',
  THONG_TIN_NGHI_PHEP: '/acs/thong-tin-nghi-phep',
  QUAN_LY_NHAN_VIEN_DIEM_DANH: '/acs/quan-ly-nhan-vien-diem-danh',
  // Quản trị nhân lực (HR)
  THUONG_PHAT: '/hrm/thuong-phat',
  SO_YEU_LY_LICH: '/hrm/so-yeu-ly-lich',
  SO_LIEU_LUONG: '/hrm/so-lieu-luong',
  CHECKLIST: '/hrm/checklist',
  CHECKLIST_INSTANCE: '/hrm/checklist/:instanceId',
  CHECKLIST_TEMPLATE: '/hrm/checklist/template',
  TUYEN_DUNG: '/hrm/tuyen-dung',
  TEST_ONLINE: '/hrm/test-online',
  QUAN_LY_DE_THI: '/hrm/quan-ly-de-thi',
  DANH_GIA_NHAN_VIEN: '/hrm/danh-gia-nhan-vien',
  GIAM_TRU_GIA_CANH: '/hrm/giam-tru-gia-canh',
  HR_DASHBOARD: '/hrm/dashboard',
  VIEC_CAN_LAM_NGAY: '/hrm/viec-can-lam-ngay',
  DANG_KY_LICH_HOC: '/hrm/dang-ky-lich-hoc',
  QUAN_LY_LICH_HOC: '/hrm/quan-ly-lich-hoc',
}
export default ROUTER
